import { gql } from 'graphql-request';

export const MARKET_REGION_STATE_FRAGMENT = gql`
    fragment MarketRegionStateFragment on MarketRegionState {
        id
        creationDate
        statDate
        cluster
        demand
    }
`